var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.534 95.0647L108.553 66.4931C109.739 65.6122 110.798 64.5716 111.696 63.4043C114.771 59.4093 114.71 53.8683 112.761 49.2333C108.425 38.9193 98.1361 31.6667 86.1332 31.6667C80.2077 31.6667 74.7002 33.4343 70.1206 36.465L25.2837 68.1258",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.534 95.0647L108.553 66.4931C109.739 65.6122 110.798 64.5716 111.696 63.4043C114.771 59.4093 114.71 53.8683 112.761 49.2333C108.425 38.9193 98.1361 31.6667 86.1332 31.6667C80.2077 31.6667 74.7002 33.4343 70.1206 36.465L25.2837 68.1258",
    stroke: "url(#paint0_linear_16725_945)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9692 85.5417C37.9692 89.9497 40.3032 98.7106 50.8934 101.115C57.2645 102.561 75.8265 96.4598 66.7445 78.7771C57.663 61.095 35.7928 61.0027 26.8965 66.9274C21.4599 70.2296 10.9017 80.5365 12.9033 94.2374C13.6138 102.538 20.1501 119.381 40.6117 120.344H103.257C109.095 119.881 110.301 119.034 114.748 115.623C120.73 110.251 130.721 100.374 136.524 93.8713C137.778 92.4666 139.132 91.0207 139.305 89.146C140.228 79.1603 125.076 83.4853 114.099 82.2953",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9692 85.5417C37.9692 89.9497 40.3032 98.7106 50.8934 101.115C57.2645 102.561 75.8265 96.4598 66.7445 78.7771C57.663 61.095 35.7928 61.0027 26.8965 66.9274C21.4599 70.2296 10.9017 80.5365 12.9033 94.2374C13.6138 102.538 20.1501 119.381 40.6117 120.344H103.257C109.095 119.881 110.301 119.034 114.748 115.623C120.73 110.251 130.721 100.374 136.524 93.8713C137.778 92.4666 139.132 91.0207 139.305 89.146C140.228 79.1603 125.076 83.4853 114.099 82.2953",
    stroke: "url(#paint1_linear_16725_945)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_945",
    x1: 25.2837,
    y1: 31.6667,
    x2: 123.749,
    y2: 70.9663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_945",
    x1: 12.6543,
    y1: 63.4075,
    x2: 128.789,
    y2: 137.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatArea);
export default __webpack_public_path__ + "static/media/mat-area.59541d0e57cd67ee9ba4cf4a0eb9a832.svg";
export { ForwardRef as ReactComponent };